import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import CommonImage from '@components/CommonImage';
import DesignItem from '@components/DesignItem';
import NoData from '@components/NoData';
import TimeBasedLoader from '@components/TimeBasedLoader';
import { toastError, toastSuccess, toastWarning } from '@components/Toast';
import AddDesignToCollection from '@components/design-uploads/AddDesignToCollection';
import BottomPopup from '@components/modals/BottomPopup';

import { useCommonTags } from '@hooks/useCommonTags';

import CollectionPresentation from '@features/collection/components/CollectionPresentation';
import TagUpdateModal from '@features/collection/details/TagUpdateModal';
import FavouriteProductsListView from '@features/favourites/components/FavouriteProductsListView';
import InventoryAndStickerModal from '@features/favourites/components/InventoryAndStickerModal';
import SampleLocationDetailsModal from '@features/favourites/components/SampleLocationDetailsModal';
import SelectFolderPopup from '@features/favourites/components/SelectFolderPopup';
import UpdateSampleLocation from '@features/favourites/components/UpdateSampleLocation';
import { groupBy } from '@features/favourites/utils/favouriteUtil';
import CreateOrderModal from '@features/order/components/CreateOrderModal';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { likeProduct } from '@store/design/action';
import { fetchFavouriteProducts } from '@store/favourite/actions';
import { storeProductData } from '@store/actions/DesignAction';

import { createSetOrder, fetchAllProductTags, toggleLockAndUnlock } from '@services/collectionService';
import { addToDraft, updateBuyerRemarks } from '@services/favouriteService';
import { getFittingResponse } from '@services/measurementService';

import { capitalizeFirstLetter, isPageReachBottom, printApiError } from '@utils/Util';

import { LIST_VIEW_TYPE, SAMPLE_REQUEST_TYPES } from '@/constants/constant';

import CreateSetOrder from '@/features/collection/details/CreateSetOrder';
import DeleteSetOrder from '@/features/collection/details/DeleteSetOrder';
import CostingAdd from '@/features/collection/components/CostingAdd';
import AddTaskModal from '@/components/AddTaskModal';
import { useDownloadTpSummaryMutation } from '@/api/commonDownloadsApi';
import UpdateFittingModal from '@/features/designTool/components/UpdateFittingModal';
import RequestTo3DAndGraphicsModal from '@/features/sampleDevelopment/components/SampleRequestModals/RequestTo3DAndGraphicsModal';
import { ENTITY_TYPE } from '@/components/rangePlan/constants';
import SampleRequestModal from '@/features/sampleDevelopment/components/SampleRequestModals/SampleRequestModal';
import { getUserTypeFromTaskValue } from '@/features/sampleDevelopment/utils';
import PhysicalSampleRequestModal from '@/features/sampleDevelopment/components/SampleRequestModals/PhysicalSampleRequestModal';
import PoAutomationPlaceModal from '@/features/sampleDevelopment/components/SampleRequestModals/PoAutomationPlaceModal';

const ProductFavourite = ({
	setIsLoading,
	designList,
	setDesignList,
	selectedProducts,
	setSelectedProducts,
	defaultViewType,
	allFavourites,
	selectedSortingOption,
	page,
	folderId,
	setPage,
	folderInfo,
	fetchDraftedProducts,
	getCategoryIdList,
	brandId,
	createFilterParams,
	artboardProducts,
	setCurrentScrolledProduct
}) => {
	const [designIdList, setDesignIdList] = useState([]);
	const [designIdToView, setDesignIdToView] = useState(null);
	const [startLoader] = useState(false);
	const [isShowAddCollectionPopup, setIsShowAddCollectionPopup] = useState(false);
	const dispatch = useDispatch();
	const scrollRef = useRef({});
	let groupedData = groupBy(designList?.data || [], selectedSortingOption?.code);
	const [isShowInventoryModal, setIsShowInventoryModal] = useState(false);
	const [isUnSelectAll, setIsUnSelectAll] = useState(false);
	const [isShowLocationModal, setIsShowLocationModal] = useState(false);
	const [selectedLocationsToDownload, setSelectedLocationsToDownload] = useState([]);
	const [isShowUpdateLocationModal, setIsShowUpdateLocationModal] = useState(false);
	const [isShowSelectFolderPopup, setIsShowSelectFolderPopup] = useState(false);
	const [isCreateNewFolder, setIsCreateNewFolder] = useState(false);
	const [isPlayPresentation, setIsPlayPresentation] = useState(false);
	const [isSelectOnNextPage, setIsSelectOnNextPage] = useState(false);
	const pageRef = useRef(page);
	const [isShowTags, setIsShowTags] = useState(false);
	const [productWiseTags, setProductWiseTags] = useState([]);
	const [isOpenPlaceOrder, setIsOpenPlaceOrder] = useState(false);
	const [productIdsWithoutBodyFabric, setProductIdsWithoutBodyFabric] = useState([]);
	const [isShowSetModal, setIsShowSetModal] = useState(false);
	const [selectedSetProduct, setSelectedSetProduct] = useState(null);
	const [selectedProductsWithDetails, setSelectedProductsWithDetails] = useState([]);
	const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState(false);
	const [showAddSamplePopup, setShowAddSamplePopup] = useState(false);
	const [showCostingPopup, setShowCostingPopup] = useState(false);
	const [setOrderType, setSetOrderType] = useState('');
	const [requestType, setRequestType] = useState('CREATE');
	const [isSharedWithBuyer, setIsSharedWithBuyer] = useState(false);
	const [isShowTaskUpdateModal, setIsShowTaskUpdateModal] = useState(false);

	const [downloadTpSummary] = useDownloadTpSummaryMutation();
	const [showBlockInfoModal, setShowBlockInfoModal] = useState();
	const [markProductId, setMarkProductId] = useState();
	const [blockSaveType, setBlockSaveType] = useState();
	const [isBottomCategory, setIsBottomCategory] = useState();
	const [fittingResponse, setFittingResponse] = useState(null);
	const [isShowSendToPdModal, setIsShowSendToPdModal] = useState(false);
	const [isShowSendTo3DModal, setIsShowSendTo3DModal] = useState(false);
	const [isShowSendToGraphicsModal, setIsShowSendToGraphicsModal] = useState(false);
	const [isShowSendToFactoryBuyerModal, setIsShowSendToFactoryBuyerModal] = useState(false);
	const [isShowSendToFactoryNitexModal, setIsShowSendToFactoryNitexModal] = useState(false);
	const [isShowTechpackHandoverModal, setIsShowTechpackHandoverModal] = useState(false);
	const [selectedProductActionId, setSelectedProductActionId] = useState(null);
	const [selectedHandoverUserType, setSelectedHandoverUserType] = useState(null);
	const [failedTaskUpdateIds, setFailedTaskUpdateIds] = useState([]);
	const [isShowReviseSampleModal, setIsShowReviseSampleModal] = useState(false);
	const [isShowPhysicalSampleModal, setIsShowPhysicalSampleModal] = useState(false);
	const [isShowPoAutomationModal, setIsShowPoAutomationModal] = useState(false);

	const commonTags = useCommonTags(
		designList?.data.map((item) => item.productResponse) || [],
		selectedProducts
	);

	useEffect(() => {
		if (folderInfo?.members?.length > 0) {
			const isSharedWithBuyer = folderInfo?.members?.some(
				(member) => member?.primaryUserType === 'EXTERNAL_USER'
			);
			setIsSharedWithBuyer(isSharedWithBuyer);
		}
	}, [folderInfo]);

	const fetchFavProducts = (currentPage = 0, size = 20) => {
		dispatch(
			fetchFavouriteProducts(
				currentPage,
				size,
				'',
				selectedSortingOption?.code,
				folderId,
				false,
				createFilterParams(),
				defaultViewType === LIST_VIEW_TYPE.LIST_VIEW
			)
		);
	};

	const fetchAllTags = async (search) => {
		try {
			dispatch(openLoader());
			let params = '?type=PRODUCT_COLLECTION_TAGS&entityActivityType=PRODUCT_TAG_UPDATE';

			if (search) {
				params += `&search=${encodeURIComponent(search)}`;
			}
			const data = await fetchAllProductTags(params);

			setProductWiseTags(data);
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			printApiError(error);
		}
	};

	const setCurrentState = (data) => {
		scrollRef.current = data;
	};

	const excludeLinkedProducts = () => {
		const filteredData = allFavourites?.data
			?.filter((product) => product?.isLinked)
			.map((product) => product?.productResponse?.id);
		return filteredData;
	};

	const excludeSoldProducts = () => {
		const getSoldProducts = allFavourites?.data
			?.filter((product) => product?.orderPlacedFromThisFolder)
			?.map((item) => item?.productResponse?.id);
		return getSoldProducts;
	};

	useEffect(() => {
		setDesignList(allFavourites);
		setCurrentState(allFavourites);
		let designIds = allFavourites?.data?.map((product) => product.id);
		setDesignIdList(designIds);
		pageRef.current = allFavourites?.totalPages;
	}, [allFavourites]);

	useEffect(() => {
		setCurrentState(allFavourites);
	}, [allFavourites]);

	useEffect(() => {
		if (page !== 0) {
			dispatch(
				fetchFavouriteProducts(
					page,
					30,
					'',
					selectedSortingOption?.code,
					folderId,
					false,
					getCategoryIdList(),
					defaultViewType === LIST_VIEW_TYPE.LIST_VIEW,
					setCurrentScrolledProduct
				)
			);
		}
	}, [page]);

	useEffect(() => {
		if (isSelectOnNextPage) {
			handleSelectAll();
		}
	}, [isSelectOnNextPage, designList?.currentPage]);

	useEffect(() => {
		document.addEventListener('scroll', handleScroll);
		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const onLastDesignReached = () => {
		if (!scrollRef.current) return;
		let { totalElements, data } = scrollRef.current;
		if (totalElements > 0 && totalElements !== data.length) {
			setPage((prev) => prev + 1);
		}
	};

	const onUpdateProductStatus = () => {
		if (!scrollRef.current) return;
		let { currentPage } = scrollRef.current;

		// Fetch all data from page 0 to current page to refresh the list
		dispatch(
			fetchFavouriteProducts(
				0,
				(parseInt(currentPage) + 1) * 30,
				'',
				selectedSortingOption?.code,
				folderId,
				false,
				createFilterParams(),
				defaultViewType === LIST_VIEW_TYPE.LIST_VIEW
			)
		);
	};

	const handleScroll = () => {
		if (isPageReachBottom()) {
			onLastDesignReached();
		}
	};

	// const onClickDesignImage = (designId) => {
	// 	setDesignIdToView(designId);
	// };

	const onCloseViewModal = () => {
		setDesignIdToView(null);
		dispatch(clearDesignViewModalInfo({}));
	};

	const onLikeProduct = (id) => {
		dispatch(likeProduct(id));
	};

	const isCollectionSelected = () => selectedSortingOption?.code === 'COLLECTION';

	const handleAddToDraft = async (designIds, isSoldFromThisFolder) => {
		try {
			if (isSoldFromThisFolder) {
				toastWarning('Sold Products can not move to draft.');
				return;
			}
			dispatch(openLoader());
			await addToDraft(designIds, folderId);
			dispatch(fetchFavouriteProducts(page, 30, '', selectedSortingOption?.code, folderId));
			fetchDraftedProducts();
			setSelectedProducts([]);
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const getDisplayName = (item, index) => {
		if (isCollectionSelected()) {
			return groupedData[item][0]?.productResponse?.collectionName;
		} else {
			return Object.keys(groupedData)[index];
		}
	};

	const getCollectionDisplayName = (item, index) => {
		return isCollectionSelected()
			? groupedData[item][0]?.productResponse?.collectionName
			: Object.keys(groupedData)[index];
	};

	const onMarkProduct = async (id, saveType, parentCatergory) => {
		setShowBlockInfoModal(true);
		setMarkProductId(id);
		setBlockSaveType(saveType);
		if (parentCatergory === 'BOTTOM') {
			setIsBottomCategory(true);
		} else {
			setIsBottomCategory(false);
		}
	};

	const renderDesignList = (item) => {
		if (item?.length > 0) {
			return item.map((design, index) => (
				<DesignItem
					design={{
						...design?.productResponse,
						addedToFavouriteDateTime: design?.addedToFavouriteDateTime,
						liked: true,
						isLinked: design?.isLinked,
						addedToFavouriteBy: design?.addedToFavouriteBy,
						orderPlacedFromThisFolder: design?.orderPlacedFromThisFolder
					}}
					isSet={design?.productResponse?.isSet}
					isPack={design?.productResponse?.isPack}
					index={index}
					selectedProducts={selectedProducts}
					setSelectedProducts={setSelectedProducts}
					setSelectedProductsWithDetails={setSelectedProductsWithDetails}
					selectedProductsWithDetails={selectedProductsWithDetails}
					onClickDesignImage={openDesignViewModal}
					key={`design_${index}`}
					onLikeProduct={onLikeProduct}
					fromPage={'FAVOURITE_PAGE'}
					onAddtoDraft={handleAddToDraft}
					productWiseTags={productWiseTags}
					fetchAllTags={fetchAllTags}
					updateProductTagOnSelect={updateProductTagOnSelect}
					showFabricStatus={productIdsWithoutBodyFabric?.includes(design?.productResponse?.id)}
					onEditSet={handleEditSet}
					setIsOpenDeleteModal={setIsOpenDeleteConfirmation}
					setSelectedSetProduct={setSelectedSetProduct}
					setRequestType={setRequestType}
					onDeleteSet={handleDeleteSet}
					artworkSoldStatus={artboardProducts[design?.productResponse?.id]}
					isSoldFolder={isSoldFolder()}
					onMarkProduct={onMarkProduct}
					handleProductUpdate={handleProductUpdate}
					fetchFavProducts={fetchFavProducts}
					failedTaskUpdateIds={failedTaskUpdateIds}
				/>
			));
		}
	};

	const renderGroupData = () => {
		return Object.keys(groupedData).map((item, index) => (
			<div className="favorite-collection-container p-0 bg-white" key={`fav_collection_${index}`}>
				<span
					onClick={() =>
						isCollectionSelected() &&
						window.open(
							`/collections/view/${groupedData[item][0]?.productResponse?.collectionId}`,
							'_blank'
						)
					}
					className="semibold-16 mr-2 cursor-pointer"
				>
					<span className="mr-2 collection-name">
						{getDisplayName(item, index)} {`(${groupedData[item]?.length})`}
					</span>
					{isCollectionSelected() && (
						<CommonImage alt="external-link" src="/icons/external-link.svg" />
					)}
				</span>

				<div className="design-list-container favourite-list-container mt-3">
					<div
						className={`design-list-row ${
							defaultViewType === LIST_VIEW_TYPE.NARROW_VIEW
								? 'narrow-view'
								: defaultViewType === LIST_VIEW_TYPE.IMAGE_VIEW
									? 'image-view'
									: ''
						}`}
					>
						{renderDesignList(groupedData[item])}
					</div>
				</div>
			</div>
		));
	};

	const renderListViewGroupData = () => {
		return Object.keys(groupedData).map((item, index) => (
			<div key={`fav_collection_${index}`} className="sample-list-details-table mb-4">
				<div
					onClick={() =>
						isCollectionSelected() &&
						window.open(
							`/collections/view/${groupedData[item][0]?.productResponse?.collectionId}`,
							'_blank'
						)
					}
					className="semibold-16 mr-2 cursor-pointer pb-3"
				>
					<span className="mr-2 collection-name">
						{getCollectionDisplayName(item, index)} {`(${groupedData[item]?.length})`}
					</span>
					{isCollectionSelected() && (
						<CommonImage alt="external-link" src="/icons/external-link.svg" />
					)}
				</div>
				<FavouriteProductsListView
					productList={groupedData[item]}
					onClickDesignImage={openDesignViewModal}
					selectedProducts={selectedProducts}
					setSelectedProducts={setSelectedProducts}
					index={index}
					productWiseTags={productWiseTags}
					fetchAllTags={fetchAllTags}
					updateProductTagOnSelect={updateProductTagOnSelect}
					setSelectedProductsWithDetails={setSelectedProductsWithDetails}
					selectedProductsWithDetails={selectedProductsWithDetails}
					isSoldFolder={isSoldFolder()}
				/>
			</div>
		));
	};

	const onReset = () => {
		setIsShowAddCollectionPopup(false);
		setSelectedProducts([]);
		setSelectedProductsWithDetails([]);
	};

	const handleSelectAll = () => {
		const designIds = designList?.data?.map((product) => product?.productResponse?.id);
		setSelectedProducts((prevSelected) => [...new Set([...prevSelected, ...designIds])]);
		setSelectedProductsWithDetails(designList?.data?.map((product) => product?.productResponse));
	};

	const getProductWithNoBodyFabric = () => {
		const listOfProduct = [];
		designList.data.forEach(({ productResponse }) => {
			if (selectedProducts.includes(productResponse?.id)) {
				if (productResponse?.isSet) {
					return productResponse?.setMemberProducts.forEach((member) => {
						if (!member.fabricDetails && !member.fabricName) {
							listOfProduct.push(productResponse);
						}
					});
				} else {
					if (!productResponse.fabricDetails && !productResponse.fabricName) {
						listOfProduct.push(productResponse);
					}
				}
			}
		});
		return listOfProduct;
	};

	const onPlaceOrder = () => {
		const productWithoutBodyFabric = getProductWithNoBodyFabric();

		if (productWithoutBodyFabric.length > 0) {
			dispatch(openLoader());
			let productIds = productWithoutBodyFabric.map((item) => item.id);
			setProductIdsWithoutBodyFabric(productIds);
			toastError('Please add body fabric for place order.');
			dispatch(closeLoader());
		} else {
			dispatch(storeProductData('selectedProductIds', selectedProducts));
			setProductIdsWithoutBodyFabric([]);
			setIsOpenPlaceOrder(true);
		}
	};

	const getProductIds = () => selectedProductsWithDetails?.map((item) => item?.id);

	const getProductWithSoldArtwork = () => {
		const selectedProductIds = getProductIds();
		return selectedProductIds?.some((id) => {
			const artboardProduct = artboardProducts[id];
			return artboardProduct && artboardProduct.status === 'SOLD';
		});
	};

	const onQuoteSampleRequest = (requestType) => {
		const productWithoutBodyFabric = getProductWithNoBodyFabric();
		const soldArtworks = getProductWithSoldArtwork();

		if (soldArtworks) {
			toastWarning(
				'This artwork has already been sold and cannot be ordered. Please select a different artwork.'
			);
			return;
		}
		if (productWithoutBodyFabric.length > 0) {
			dispatch(openLoader());
			let productIds = productWithoutBodyFabric.map((item) => item.id);
			dispatch({
				type: 'SET_PRODUCT_DATA',
				payload: {
					key: 'productsWithoutBodyFabric',
					data: productWithoutBodyFabric
				}
			});
			toastError(`Please add body fabric for ${capitalizeFirstLetter(requestType)} request.`);
			setProductIdsWithoutBodyFabric(productIds);
			dispatch(closeLoader());
			return;
		}

		if (requestType === 'QUOTE') {
			setShowCostingPopup(true);
			setProductIdsWithoutBodyFabric([]);
		} else {
			setShowAddSamplePopup(true);
			setProductIdsWithoutBodyFabric([]);
		}
	};

	const createPack = async () => {
		try {
			dispatch(openLoader());
			let params = `?entityId=${folderId}&entityType=FAVOURITE_FOLDER&name=${encodeURIComponent(selectedProductsWithDetails[0].referenceNumber)}&productId=${
				selectedProductsWithDetails[0].id
			}`;

			const data = await createSetOrder('create-pack', params);
			if (data) {
				fetchFavProducts();
				handleRestState();
			}
			dispatch(closeLoader());
		} catch (error) {
			printApiError(error);
			dispatch(closeLoader());
		}
	};

	const handleRestState = () => {
		setProductIdsWithoutBodyFabric([]);
		setSelectedProducts([]);
		setSelectedProductsWithDetails([]);
		setIsUnSelectAll(false);
		setIsSelectOnNextPage(false);
		setIsShowInventoryModal(false);
		setSetOrderType('');
		setRequestType('CREATE');
	};

	const onClickTechpackLockUnlock = async (lock) => {
		dispatch(openLoader());
		const { payload } = await toggleLockAndUnlock(selectedProducts, lock);
		if (payload && payload.length > 0) {
			let modifiedProductList = [];
			modifiedProductList = designList?.data?.map((product) => {
				const selectedProduct = payload.find(
					(item) => item.productId === product?.productResponse?.id
				);
				if (selectedProduct) {
					product.productResponse.isLocked = selectedProduct.isLocked;
					product.productResponse.lockedBy = selectedProduct.lockedBy;
					product.productResponse.lockedByName = selectedProduct.lockedByName;
					product.productResponse.lockedDate = selectedProduct.lockedDate;
					return {
						...product
					};
				} else return product;
			});
			setDesignList((prev) => ({ ...prev, data: modifiedProductList }));
		}
		await onClearSelectedProducts();
		dispatch(closeLoader());
	};

	const handleProductUpdate = async (productList) => {
		if (productList?.length > 0) {
			let modifiedProductList = [];
			modifiedProductList = designList?.data?.map((product) => {
				const selectedProduct = productList.find(
					(item) => item.productId === product?.productResponse?.id
				);
				if (selectedProduct) {
					product.productResponse.isLocked = selectedProduct.isLocked;
					return {
						...product
					};
				} else return product;
			});
			setDesignList((prev) => ({ ...prev, data: modifiedProductList }));
		}
		await onClearSelectedProducts();
		dispatch(closeLoader());
	};

	const handleTpHandover = (actionType) => {
		setSelectedProductActionId(actionType?.id);
		setSelectedHandoverUserType(actionType);
		setIsShowTechpackHandoverModal(true);
	};

	const onActionClick = (type, actionType) => {
		// This request task has no backend constant, so it is matched by name.
		if (actionType?.name === 'Place Order (AI-assisted)') {
			setIsShowPoAutomationModal(true);
			return;
		}

		switch (type) {
			case 'COLLECTION':
				setIsShowAddCollectionPopup(true);
				break;
			case 'DOWNLOAD_REPORT':
				downloadReportByProductIds(selectedProducts);
				break;
			case 'ORDER_PLACED':
				onPlaceOrder();
				break;
			case 'SAMPLE_LOCATION_DETAILS':
				setIsShowLocationModal(true);
				break;
			case 'FETCH_NEXT_PAGE':
				setPage(page + 1);
				setIsSelectOnNextPage(true);
				break;
			case 'UPDATE_SAMPLE_LOCATION':
				setIsShowUpdateLocationModal(true);
				break;
			case 'MOVE_TO_DRAFT':
				const linkedProductIds = excludeLinkedProducts();
				const soldProductIds = excludeSoldProducts();
				const validProductIds = selectedProducts.filter((id) => !linkedProductIds?.includes(id));
				const soldProductIdsInSelectedProducts = selectedProducts?.filter(
					(id) => !soldProductIds.includes(id)
				);

				if (validProductIds.length !== selectedProducts.length) {
					toastWarning('Some selected products are linked and cannot be drafted');
					return;
				}

				if (soldProductIdsInSelectedProducts.length !== selectedProducts.length) {
					toastWarning('Sold Products can not move to draft.');
					return;
				}
				if (validProductIds.length) {
					handleAddToDraft(validProductIds.join(','));
				}
				break;
			case 'INVENTORY_STICKER':
				setIsShowInventoryModal(true);
				break;
			case 'SELECT_ALL':
				setIsUnSelectAll(true);
				handleSelectAll();
				break;
			case 'ADD_FOLDER':
				setIsShowSelectFolderPopup(true);
				break;
			case 'PRESENTATION':
				setIsPlayPresentation(true);
				break;
			case 'ADD_TAG':
				setIsShowTags(true);
				break;
			case 'CREATE_SET':
				setIsShowSetModal(true);
				break;
			case 'CREATE_PACK':
				createPack();
				break;
			case 'BUYER_COSTING_REQUESTED':
				onQuoteSampleRequest('QUOTE');
				break;
			case 'BUYER_COSTING_REQUESTED_FROM_AM_BDM':
				onQuoteSampleRequest('QUOTE');
				break;
			case 'BUYER_COSTING_REQUESTED_FROM_BUYER_PLATFORM':
				onQuoteSampleRequest('QUOTE');
				break;
			case 'TASK_UPDATE':
				setIsShowTaskUpdateModal(true);
				break;
			case 'CLEAR':
				handleRestState();
				break;
			case 'LOCK_TECHPACK':
				onClickTechpackLockUnlock(true);
				break;
			case 'UNLOCK_TECHPACK':
				onClickTechpackLockUnlock(false);
			case 'SEND_TO_SAMPLE_SECTION':
				onQuoteSampleRequest(SAMPLE_REQUEST_TYPES.SAMPLE);
				break;
			case 'SEND_TO_FACTORY_BUYER_DESIGN':
				setIsShowSendToFactoryBuyerModal(true);
				break;
			case 'SEND_TO_FACTORY_NITEX_DESIGN':
				setIsShowSendToFactoryNitexModal(true);
				break;
			case 'SEND_TO_PD':
				setIsShowSendToPdModal(true);
				break;
			case 'TP_HANDOVER':
				setSelectedProductActionId(actionType?.id);
				setIsShowTechpackHandoverModal(true);
				break;
			case 'REQUEST_3D':
				setIsShowSendTo3DModal(true);
				break;
			case 'REQUEST_GRAPHICS':
				setIsShowSendToGraphicsModal(true);
				break;
			case 'TP_HANDOVER':
				handleTpHandover(actionType);
				break;
			case 'SEND_REVISE_SAMPLE_REQUEST':
				setIsShowReviseSampleModal(true);
				break;
			case 'TP_HANDOVER_TO_PROJECT_TEAM':
				handleTpHandover(actionType);
				break;
			case 'TP_HANDOVER_TO_PATTERN_SECTION':
				handleTpHandover(actionType);
				break;
			case 'TP_HANDOVER_TO_ACCOUNT_MANAGER':
				handleTpHandover(actionType);
				break;
			case 'INVENTORY_SAMPLE_REQUEST':
				setIsShowPhysicalSampleModal(true);
				break;
			case 'TP_HANDOVER_TO_DESIGNER':
				handleTpHandover(actionType);
				break;
			default:
				break;
		}
	};

	const downloadReportByProductIds = (productIds = []) => {
		downloadTpSummary({ productIds, inventoryCountryIds: selectedLocationsToDownload })
			.unwrap()
			.then(() => {
				setIsShowLocationModal(false);
				setSelectedLocationsToDownload([]);
			});
	};

	useEffect(() => {
		if (designIdToView !== null) {
			openDesignViewModal();
		}
	}, [designIdToView]);

	const isRegularSort = () => {
		return (
			selectedSortingOption?.code === 'NEWEST' ||
			selectedSortingOption?.code === 'OLDEST' ||
			selectedSortingOption?.code === 'STYLE_NO'
		);
	};

	const openDesignViewModal = (item) => {
		dispatch(
			setDesignViewModalInfo({
				mergeProductList: item?.setMemberProductIds || [],
				isShowMergeTechPack: item?.isSet,
				id: item?.id,
				onCloseViewModal: onCloseViewModal,
				updateProductStatus: () =>
					dispatch(
						fetchFavouriteProducts(page, 30, '', selectedSortingOption?.code, folderId)
					).finally(() => {
						setIsLoading(false);
					}),
				source: 'PRODUCT_LIST',
				designIdList: designIdList,
				loadMoreDesign: true,
				onLastDesignReached: onLastDesignReached,
				isSoldFolder: isSoldFolder()
			})
		);
	};

	const isHideSetOrder = () => {
		return false;
	};

	const handleCopyToFolder = (selectedFolder, handleSuccess) => {
		dispatch(likeProduct(selectedProducts, () => handleSuccess(selectedFolder), '', selectedFolder?.id));
	};

	const getRemainingStyles = () => {
		const totalElements = designList?.totalElements || 0;
		const selectedCount = selectedProducts?.length || 0;
		const remaining = totalElements - selectedCount;

		return remaining < 30 ? remaining : 30;
	};

	const updateProductTagOnSelect = (payload) => {
		const updatedProducts = designList?.data?.map((product) => {
			const matchingPayload = payload.find((item) => item.id === product?.productResponse?.id);
			if (matchingPayload) {
				return {
					...product,
					productResponse: {
						...product.productResponse,
						tagResponseList: matchingPayload.tagResponseList
					}
				};
			}
			return product;
		});

		setDesignList((prev) => ({
			...prev,
			data: updatedProducts
		}));
	};

	const isShowRepeatOrderTag = () => {
		let soldIds = designList?.data
			.filter((item) => item.productResponse.availabilityStatus === 'SOLD')
			?.map((item) => item.productResponse.id);
		return selectedProducts.some((id) => soldIds.includes(id));
	};

	const updateProductCards = () => {
		fetchFavProducts();
		handleRestState();
	};

	const handleEditSet = (type, item) => {
		setSetOrderType(type);
		setSelectedSetProduct(item);
		setIsShowSetModal(true);
	};

	const handleDeleteSet = (type, item) => {
		setSetOrderType(type);
		setSelectedSetProduct(item);
		setIsOpenDeleteConfirmation(true);
	};

	const isShowSetPackOption = () => {
		const hasSetOrPack = selectedProductsWithDetails.some((item) => item?.isSet || item?.isPack);

		if (hasSetOrPack) {
			return {};
		}

		const eligibleProducts = selectedProductsWithDetails.filter((item) => !item?.isSet && !item?.isPack);

		if (eligibleProducts?.length === 1) {
			return {
				id: 'CREATE_PACK',
				title: 'Create Pack',
				value: 'CREATE_PACK'
			};
		}

		if (eligibleProducts?.length > 1) {
			return {
				id: 'CREATE_SET',
				title: 'Create Set',
				value: 'CREATE_SET'
			};
		}

		return {};
	};

	const getSelectedProductIdsWithSetMember = () => {
		const ids = [];

		selectedProductsWithDetails.forEach((item) => {
			if (item?.isSet) {
				item?.setMemberProductIds.forEach((member) => {
					ids.push(member);
				});
			} else {
				ids.push(item.id);
			}
		});

		return ids;
	};

	const onClearSelectedProducts = async () => {
		await dispatch(storeProductData('selectedProductIds', []));
		setSelectedProducts([]);
	};

	const onUpdateBuyerRemarks = async (productId, buyerRemarks, prevBuyerRemarks, addedToFavouriteById) => {
		if (prevBuyerRemarks === buyerRemarks) {
			return;
		}
		dispatch(openLoader());
		try {
			await updateBuyerRemarks(folderId, productId, buyerRemarks, addedToFavouriteById);
			let updatedProduct = designList?.data?.map((item) => {
				if (item.productResponse.id === productId) {
					item.buyerRemarks = buyerRemarks;
				}
				return item;
			});
			setDesignList((prev) => ({ ...prev, data: updatedProduct }));
			dispatch(closeLoader());
			toastSuccess('Buyer remarks updated successfully');
		} catch (error) {
			dispatch(closeLoader());
			printApiError(error);
		}
	};

	const isSoldFolder = () => folderInfo?.name === 'Sold Interest';
	const updateProductCardOnMark = (data) => {
		let tmpProductList = [...designList?.data];

		let updatedProduct = data;
		tmpProductList = tmpProductList.map((product) => {
			if (product.productResponse.id === updatedProduct.id) {
				return {
					...product,
					productResponse: {
						...product.productResponse,
						isBlock: updatedProduct.isBlock
					}
				};
			}
			return product;
		});

		setDesignList((prev) => ({
			...prev,
			data: tmpProductList
		}));
	};

	useEffect(() => {
		fetchFittingResponse();
	}, [markProductId]);

	const fetchFittingResponse = async () => {
		if (markProductId) {
			try {
				dispatch(openLoader());
				const data = await getFittingResponse(markProductId);
				setFittingResponse(data);
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	const handleOnFittingUpdate = async () => {
		try {
			dispatch(openLoader());
			setShowBlockInfoModal(false);
			toastSuccess('Updated successfully');
			await fetchFittingResponse();
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const onCloseUpdateFittingInfoModal = () => {
		setShowBlockInfoModal(false);
		setFittingResponse(null);
	};

	const getSelectdProductIdsWithSetMembers = () => {
		const ids = [];
		selectedProductsWithDetails?.forEach((item) => {
			if (item?.isSet) {
				ids.push(...item?.setMemberProductIds);
			} else {
				ids.push(item?.id);
			}
		});
		return ids;
	};

	return allFavourites?.data?.length === 0 ? (
		<div className="no-favorite">
			<NoData message={'No favourite added yet'} />
		</div>
	) : (
		<>
			{defaultViewType === LIST_VIEW_TYPE.LIST_VIEW ? (
				<div className="favorite-collection-wrapper">
					<div className="favorite-collection-container p-0 bg-white">
						{isRegularSort() ? (
							<FavouriteProductsListView
								productList={designList?.data}
								onClickDesignImage={openDesignViewModal}
								selectedProducts={selectedProducts}
								setSelectedProducts={setSelectedProducts}
								productWiseTags={productWiseTags}
								fetchAllTags={fetchAllTags}
								updateProductTagOnSelect={updateProductTagOnSelect}
								setSelectedProductsWithDetails={setSelectedProductsWithDetails}
								selectedProductsWithDetails={selectedProductsWithDetails}
								isSharedWithBuyer={isSharedWithBuyer}
								onUpdateBuyerRemarks={onUpdateBuyerRemarks}
								isSoldFolder={isSoldFolder()}
							/>
						) : (
							renderListViewGroupData()
						)}
					</div>
				</div>
			) : (
				<div className="favorite-collection-wrapper">
					{isRegularSort() ? (
						<div className="favorite-collection-container p-0 bg-white">
							<div className="design-list-container favourite-list-container mt-3">
								<div
									className={`design-list-row ${
										defaultViewType === LIST_VIEW_TYPE.NARROW_VIEW
											? 'narrow-view'
											: defaultViewType === LIST_VIEW_TYPE.IMAGE_VIEW
												? 'image-view'
												: ''
									}`}
								>
									{renderDesignList(designList?.data)}
								</div>
							</div>
						</div>
					) : (
						renderGroupData()
					)}
				</div>
			)}
			{selectedProducts?.length > 0 && (
				<BottomPopup
					length={`${selectedProducts?.length}/${designList?.totalElements}`}
					type={'FAVOURITE_PAGE'}
					showUnSelectAll={isUnSelectAll}
					onActionClick={(type, actionType) => onActionClick(type, actionType)}
					isHideSetOrder={isHideSetOrder}
					isDisableFetchNextPage={getRemainingStyles() === 0}
					remainingStyles={getRemainingStyles()}
					setPackOption={isShowSetPackOption()}
				/>
			)}
			{isShowUpdateLocationModal && (
				<UpdateSampleLocation
					setIsShowUpdateLocationModal={setIsShowUpdateLocationModal}
					selectedProductIds={getSelectedProductIdsWithSetMember()}
					isOnTheWay
				/>
			)}
			<div className={`${isShowSelectFolderPopup ? 'show' : 'hide'}`}>
				<SelectFolderPopup
					title="Add to Folder"
					isShowCreateNew={isCreateNewFolder}
					setIsShowCreateNew={setIsCreateNewFolder}
					onClose={() => setIsShowSelectFolderPopup(false)}
					handleCopyToFolder={handleCopyToFolder}
					favFrom="FAVOURITE"
				/>
			</div>
			{isShowLocationModal && (
				<SampleLocationDetailsModal
					onClose={() => {
						setSelectedLocationsToDownload([]);
						setIsShowLocationModal(false);
					}}
					downloadReportByProductIds={downloadReportByProductIds}
					selectedLocationsToDownload={selectedLocationsToDownload}
					setSelectedLocationsToDownload={setSelectedLocationsToDownload}
					selectedProductIds={getSelectedProductIdsWithSetMember(selectedProductsWithDetails)}
				/>
			)}
			{isShowInventoryModal && (
				<InventoryAndStickerModal
					onClose={() => setIsShowInventoryModal(false)}
					isDesignEdit={true}
					productIds={getSelectedProductIdsWithSetMember()}
					designList={designList?.data}
					setIsShowInventoryModal={setIsShowInventoryModal}
					onSuccess={() =>
						dispatch(fetchFavouriteProducts(page, 20, '', selectedSortingOption?.code, folderId))
					}
				/>
			)}
			<CollectionPresentation
				isPlay={isPlayPresentation}
				collectionName={folderInfo?.name}
				collectionId={folderId}
				onCLoseModal={() => setIsPlayPresentation(false)}
				entityType="FAVOURITE_FOLDER"
				selectedProductIds={selectedProducts}
			/>
			{startLoader && <TimeBasedLoader startLoader={startLoader} />}
			{isShowAddCollectionPopup && (
				<AddDesignToCollection
					type="ADD_NEW"
					title="Copy to collection"
					onAddDesign={onReset}
					onCancel={onReset}
					isMoveActive={false}
					designIdList={selectedProducts}
				/>
			)}
			{isShowTags && (
				<TagUpdateModal
					type="ADD_NEW"
					title="Tag"
					onCancel={() => {
						setIsShowTags(false);
					}}
					allTagList={productWiseTags}
					commonTags={commonTags}
					updateTagList={updateProductTagOnSelect}
					fetchAllTags={fetchAllTags}
					favouriteProductIdList={selectedProducts}
					isFavouriteProduct={true}
				/>
			)}
			{isOpenPlaceOrder && (
				<CreateOrderModal
					isShowRepeatOrderTag={isShowRepeatOrderTag()}
					onClose={async () => {
						setIsOpenPlaceOrder(false);
						onActionClick('CLEAR');
						dispatch(storeProductData('selectedProductIds', []));
					}}
					brandId={brandId}
					folderId={folderId}
				/>
			)}
			{isShowSetModal && (
				<CreateSetOrder
					requestType={requestType}
					setOrderType="SET"
					onClose={() => {
						setIsShowSetModal(false);
						setRequestType('CREATE');
					}}
					productIds={selectedProducts}
					updateProductCard={updateProductCards}
					selectedProduct={selectedSetProduct}
					entityId={folderId}
					entityType={'FAVOURITE_FOLDER'}
				/>
			)}

			{isOpenDeleteConfirmation && (
				<DeleteSetOrder
					selectedProduct={selectedSetProduct}
					setOrderType={setOrderType}
					onClose={() => {
						setSelectedSetProduct(null);
						setIsOpenDeleteConfirmation(false);
						setSetOrderType('');
					}}
					updateProductCard={updateProductCards}
				/>
			)}

			{/* {showAddSamplePopup && (
				<SampleAdd
					requestType="SAMPLE"
					requestFrom="FAVOURITE"
					source="DESIGN"
					selectedDesignIds={selectedProducts}
					onClose={async () => {
						setShowAddSamplePopup(false);
						await onClearSelectedProducts();
					}}
				/>
			)} */}

			{showCostingPopup && (
				<CostingAdd
					requestFrom="FAVOURITE"
					selectedDesignIds={selectedProducts}
					onClose={async () => {
						setShowCostingPopup(false);
						await onClearSelectedProducts();
					}}
				/>
			)}
			{isShowTaskUpdateModal && (
				<AddTaskModal
					onClose={() => {
						// if (taskName) {
						// 	setTaskInputValueFromTaskModal(taskName);
						// }
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
						setIsShowTaskUpdateModal(false);
					}}
					// onOpenAddNewTaskModal={() => setIsShowCreateNewTaskModal(true)}
					productIdList={getSelectdProductIdsWithSetMembers()}
					onSuccess={() => {
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
						onUpdateProductStatus();
					}}
					onError={setFailedTaskUpdateIds}
				/>
			)}
			{/* {isShowCreateNewTaskModal && (
				<CreateNewTask
					onClose={() => setIsShowCreateNewTaskModal(false)}
					onOpenTaskModal={() => setIsShowTaskUpdateModal(true)}
					taskInputValueFromTaskModal={taskInputValueFromTaskModal}
				/>
			)} */}

			{showBlockInfoModal && (
				<UpdateFittingModal
					productId={markProductId}
					isShowClose={true}
					blockResponse={fittingResponse}
					onAddSuccess={handleOnFittingUpdate}
					onCloseModal={() => onCloseUpdateFittingInfoModal()}
					blockSaveType={blockSaveType}
					updateProductCardOnMark={updateProductCardOnMark}
					openedFrom={'collection'}
					isBottomCategory={isBottomCategory}
				/>
			)}

			{showAddSamplePopup && (
				<SampleRequestModal
					onClose={() => {
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
						setShowAddSamplePopup(false);
					}}
					productIds={selectedProducts}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SAMPLE}
					title="Send to Sample Section"
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}

			{isShowReviseSampleModal && (
				<SampleRequestModal
					onClose={() => {
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
						setIsShowReviseSampleModal(false);
					}}
					productIds={selectedProducts}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SEND_REVISE_SAMPLE_REQUEST}
					title="Send to Sample Section"
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowTechpackHandoverModal && (
				<SampleRequestModal
					onClose={() => {
						setSelectedProductActionId(null);
						setIsShowTechpackHandoverModal(false);
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
					}}
					productIds={selectedProducts}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={selectedHandoverUserType?.taskValueType?.constant}
					title={selectedHandoverUserType?.name || 'Techpack handover'}
					taskValueType={selectedHandoverUserType?.taskValueType?.constant}
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					productActionId={selectedProductActionId}
					selectedHandoverUserType={getUserTypeFromTaskValue(
						selectedHandoverUserType?.taskValueType?.constant
					)}
					handoverModalFor={selectedHandoverUserType?.taskValueType?.constant}
					isHandoverModal={true}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowSendToPdModal && (
				<SampleRequestModal
					onClose={() => {
						setIsShowSendToPdModal(false);
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
					}}
					productIds={selectedProducts}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE}
					title="Send to PD"
					taskValueType={SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE}
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
				// <PhysicalSampleRequestModal selectedDesigns={selectedProducts} />
			)}
			{isShowSendToFactoryNitexModal && (
				<SampleRequestModal
					onClose={() => {
						setIsShowSendToFactoryNitexModal(false);
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
					}}
					productIds={selectedProducts}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_NITEX_DESIGN}
					title="Send to Factory (Nitex design Development)"
					onRefetch={() => onUpdateProductStatus()}
					taskValueType={SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_NITEX_DESIGN}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowSendToFactoryBuyerModal && (
				<SampleRequestModal
					onClose={() => {
						setIsShowSendToFactoryBuyerModal(false);
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
					}}
					productIds={selectedProducts}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_BUYER_DESIGN}
					title="Send to Factory (Buyer Techpack)"
					taskValueType={SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_BUYER_DESIGN}
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowSendTo3DModal && (
				<RequestTo3DAndGraphicsModal
					title="Send 3D design request"
					onClose={() => {
						setIsShowSendTo3DModal(false);
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
					}}
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_3D}
					productIds={selectedProducts}
					onRefetch={() => onUpdateProductStatus()}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowSendToGraphicsModal && (
				<RequestTo3DAndGraphicsModal
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_GRAPHIC}
					title="Send Graphics team for design & placement"
					onClose={() => {
						setIsShowSendToGraphicsModal(false);
						setSelectedProducts([]);
						setSelectedProductsWithDetails([]);
					}}
					productIds={selectedProducts}
					onRefetch={() => onUpdateProductStatus()}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowPhysicalSampleModal && (
				<PhysicalSampleRequestModal
					onClose={() => {
						setIsShowPhysicalSampleModal(false);
						onClearSelectedProducts();
					}}
					selectedDesigns={selectedProducts}
					setSelectedProdutIds={setSelectedProducts}
				/>
			)}
			{isShowPoAutomationModal && (
				<PoAutomationPlaceModal
					folderId={folderId}
					onClose={() => {
						setIsShowPoAutomationModal(false);
						onClearSelectedProducts();
					}}
				/>
			)}
		</>
	);
};

export default ProductFavourite;
